import moment from 'moment';

export default date => {
    return moment(String(date)).format('D MMM YYYY');
};
